/* eslint no-console: "off" */
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
// eslint-disable-next-line import/no-extraneous-dependencies
import { composeWithDevTools } from 'remote-redux-devtools';

// import { routerMiddleware } from 'react-router-redux';
import { routerMiddleware } from 'connected-react-router';
import { ReactReduxContext } from 'react-redux';

import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';


import { firebaseConfig } from '../../config';

import rootReducer from '../reducers';
import rootSaga from '../sagas'; // TODO: Next step

const rrfConfig = {
  userProfile: 'users', // where profiles are stored in database
  // ???? NOT WORKING
  profileFactory: (userData) => { // how profiles are stored in database
    const { user } = userData;
    return {
      email: user.email,
      displayName: user.displayName,
      uid: user.uid,
      id: user.uid,
    };
  },
  presence: 'presence', // where list of online users is stored in database
  sessions: 'sessions', // where list of user sessions is stored in database (presence must be enabled)
};

// initialize firebase instance
// const firebaseApp = 
firebase.initializeApp(firebaseConfig); // <- new to v2.*.*

const configureStore = (history) => {
  const sagaMiddleware = createSagaMiddleware();
  // console.log('1 ', rootReducer);
  // console.log('3 ', routerMiddleware(history));
  // console.log('2 ', reactReduxFirebase(firebaseApp, rrfConfig));
  return {
    ...createStore(
      /* 1 */ rootReducer(history),
      /* 2.1 */ composeWithDevTools(
        applyMiddleware(
          sagaMiddleware,
          routerMiddleware(history),
        ),
        // reactReduxFirebase(firebaseApp, rrfConfig),
      ),
    ),
    runSaga: sagaMiddleware.run(rootSaga),
  };
};

//const contextA = React.createContext();
export { rrfConfig, ReactReduxContext as contextA };
export default configureStore;



// WEBPACK FOOTER //
// ./src/redux/store/configureStore.js